var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-main"},[_c('h4',[_vm._v("可用资源")]),_vm._v(" "),_c('div'),_vm._v(" "),_c('h4',[_vm._v("作业")]),_vm._v(" "),_c('div')])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-357a7b74","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/workspace/components/Resource.vue
// module id = null
// module chunks = 